import i18next from 'i18next';

export const getButtons = (tryLater, changeDispatchMethod) => [
  {
    text: i18next.t('NoRiders:changeToPickup'),
    onClick: changeDispatchMethod
  },
  {
    text: i18next.t('NoRiders:tryLater'),
    onClick: tryLater
  }
];
